import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
    name: "dateTimeFormatter",
    standalone: false
})
export class DateTimeFormatter implements PipeTransform {
  /**
   *  This pipe takes a date-time and a format and returns the date-time formatted
   * @param dateTime  date-time to format
   * @param outputFormat  format to apply
   * @returns  date-time formatted
   * @example  date | dateTimeFormatter : expectedDateFormat
   */
  transform(dateTime: string, outputFormat: string): string {
    if (outputFormat == "") {
      return dateTime;
    } else {
      return moment(dateTime).format(outputFormat);
    }
  }
}
